import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import jwt_decode from 'jwt-decode';

import useDebounce from 'hooks/useDebounce';
import Tabs from 'modules/ClientCommunication/components/Tabs/Tabs';
import MonthlyBoard from 'modules/ClientCommunication/components/MonthlyBoard/MonthlyBoard';
import AllEmails from 'modules/ClientCommunication/components/AllEmailsTable/AllEmails';
import Filters from 'modules/ClientCommunication/components/Filters/Filters';
import StatisticsContent from 'modules/ClientCommunication/components/StatisticCards/StatisticsContent';

import { useClientCommunicationContext } from 'context/clientCommunication.context';

import { useStylesClientCommunication } from 'modules/ClientCommunication/pages/ClientCommunication/ClientCommunication.styles';

import { LocaleStorageTokenList, LocalStorage } from 'helpers/Storage';

import ROUTES from 'constants/routes';

import './style.scss';

const ClientCommunication: React.FC = () => {
  const navigate = useNavigate();
  const styles = useStylesClientCommunication();
  const accessToken = LocalStorage.get(LocaleStorageTokenList.access_token);

  const { role: roleFromToken } =
    accessToken &&
    jwt_decode<any>(accessToken);

  const {
    selectedTimePeriod,
    searchValue,
    setSelectedFsmsIds,
    setSelectedFsms,
    activeTab,
    setDebouncedSearchValue,
  } = useClientCommunicationContext();

  const debauncedValue = useDebounce(searchValue, 1000);

  useEffect(() => {
    setDebouncedSearchValue(debauncedValue);
    // eslint-disable-next-line
  }, [debauncedValue]);

  useEffect(() => {
    LocalStorage.set("activeTab", activeTab);

    return () => {
      setSelectedFsmsIds([]);
      setSelectedFsms([]);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    LocalStorage.set("activeTab", activeTab);
    return () => {
      LocalStorage.remove("activeTab");
    };
  }, [activeTab]);

  return (
    <div className={styles.emailReports}>
      <div className={styles.header}>
        <h1 className={styles.title}>Client communication</h1>
        <button
          className="auth-button"
          style={{ width: 'unset', margin: '0' }}
          onClick={() => {
            navigate(ROUTES.MONTHLY_STRATEGY_UPDATE);
          }}
        >
          Monthly Strategy Update
        </button>
      </div>
      <StatisticsContent roleFromToken={roleFromToken} selectedTimePeriod={selectedTimePeriod} />
      <Tabs />
      <Filters />
      {activeTab === "monthlyBoard" ? <MonthlyBoard /> : <AllEmails />}
    </div>
  );
};

export default ClientCommunication;
